import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LazyHydrate from 'react-lazy-hydration';
import scrollToComponent from 'react-scroll-to-component-ssr';
import { JsonLd } from 'react-schemaorg';
import { isMobileSafari } from 'react-device-detect';
import Fullscreen from 'react-full-screen';
import each from 'lodash/each';
import sortBy from 'lodash/sortBy';
import toNumber from 'lodash/toNumber';
import map from 'lodash/map';
import get from 'lodash/get';
import filter from 'lodash/filter';
// import findIndex from 'lodash/findIndex';
import every from 'lodash/every';
import replace from 'lodash/replace';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import urlShortener from 'helpers/urlShortener';
import formatDate from 'helpers/formatDate';
import { numDescOnlyText } from 'helpers/numDesc';
import beautifyNumber from 'helpers/beautifyNumber';
import absoluteUrl from 'helpers/absoluteUrl';
// import { setBackUrl } from 'helpers/back-url-store';
import seoPreload, { seoDecorator } from 'api/seo';
import DataProvider from 'api/data-provider';
import Dict from 'api/data-dict';
import preload from 'api/data-preload';
import { simpleCheck } from 'api/data-check';
import Counter from 'subsys/counter';
import AskQuestion, { ViberPhone, TelegramPhone } from 'subsys/ask-question';
import { FavoriteWrapper } from 'subsys/favorites';
import { marketStatEvents, mstatDecorator } from 'subsys/market-stat';
import { InputListBox } from 'containers/form';
import { Maps, BaseLayersUser, InfoLayer, FullscreenControl } from 'containers/maps';
import Image, { Thumb, OpenGraphImage } from 'components/image';
import { AbstractQueryPage } from 'components/view-map-search';
import TabJSControl from 'components/tab-js-control';
import CollapseLines from 'components/clamp-lines';
import Icon, { iconTypes, socialsIconConfig } from 'components/icon';
// import { ModalButton, Content } from 'components/modal';
import Breadcrumbs from 'components/breadcrumbs';
import Container from 'components/container';
import { SeoText } from 'components/layouts';
import Row, { Col } from 'components/row';
import Button from 'components/button';
import Link from 'components/link';
import { HideTelephoneSeo } from 'components/hide-telephone';
import sensor from 'components/sensor';
import { changeDevice } from 'components/view-map-search/view-search';
import contentBlock, { blockPreloader } from 'containers/content-block';

import linksDomik from 'src-sites/domik/links';
import blockConfig from 'src-sites/domik/blocks/config';
import BlockWrapper from 'src-sites/domik/blocks/block-wrapper';

import { getHousesCounter } from '../section-project/render-common';
import TileCard from '../section-projects/tile-card';
import { ordersLC } from '../section-projects/orders';
import marker from '../assets/map-marker';

import translates from './developer-i18n';

import 'styles/domik/section-developer/_page-developer.scss';

const bemClasses = new Bem('developer');
// const classesSearch = new Bem('pageSearch');

@preload((routeProps) => {
  const { location } = routeProps;
  const { landing } = routeProps.params;
  const { query = {} } = location;

  const localityInfo = landing.params.projects ? {
    locality: [DataProvider.preload, {
      url: 'landing/location-info',
      cache: 60 * 24,
      query: { id: landing.params.projects.locality },
      preloaderCacheId: 'locationInfolocality',
      requestClientCache: 'locality'
    }] } : {};

  return {
    ...blockPreloader({
      project: 'domik',
      entity: 'developerPage'
    }, blockConfig, []),
    dev: [DataProvider.preload, {
      url: 'domik/users/developer',
      query: { id: landing.params.developer.id },
      requestClientCache: 1
    }],
    childLandings: [DataProvider.preload, {
      url: 'helpers/landings',
      query: { branch: landing.tree },
      requestClientCache: 1
    }],
    projects: [DataProvider.preload, {
      url: 'domik/location/newbuilds-list',
      queryJson: true,
      query: {
        creator: landing.params.developer.id,
        locality: landing.params.projects ? landing.params.projects.locality : null,
        order: ordersLC()[0].param,
        limit: 500,
        ...query
      },
      requestClientCache: 1
    }],
    ...localityInfo,
    ...seoPreload({
      entity: landing.params.projects ? 'dev-regional' : 'developer'
    }, ['dev', ...Object.keys(localityInfo)]),
    ...simpleCheck(['dev'])
  };
})
@seoDecorator({
  advancedVars: {
    projectsHeader: 'Заголовок H2',
    bottomText: 'Текст в самом низу'
  }
})
@mstatDecorator(marketStatEvents.historyChange, params => ({
  entity: 'Карта застройщика',
  entityId: get(params, 'dev.data[0].id')
}))
@sensor
@I18nHoc(translates())
export default class PageDeveloper extends AbstractQueryPage {
  static propTypes = {
    className: PropTypes.string,
    params: PropTypes.shape({
      developer: PropTypes.string,
      branchUrl: PropTypes.string,
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ])
    }),
    childLandings: PropTypes.shape({}),
    dev: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    seoData: PropTypes.shape({}),
    projects: PropTypes.shape({}),
    firstCount: PropTypes.number,
    addedCount: PropTypes.number,
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;

    this.tileCard = TileCard;
    this.project = 'domik';
    this.needCount = true;

    this.state = {
      isFullScreenMode: false,
      fullMapLegend: false,
      handleMarkerId: null
    };
  }

  componentDidMount() {
    this.needCount = false;
    // this._clearBackUrl();
    this.onHandleResize(this.sensor.getRuntime());
  }

  // componentDidUpdate() {
  //   this._clearBackUrl();
  // }

  // _clearBackUrl() {
  //   setBackUrl();
  // }

  componentWillUnmount() {
    clearTimeout(this.autoCloseMapLegendDelay);
    clearTimeout(this.closeMapLegendDelay);
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    changeDevice.call(this, desktop, tablet, phone);
  }

  renderNaviRegion() {
    const { i18n } = this;
    const { seoData, params, childLandings, location } = this.props;
    const { query } = location;
    const childTabs = [];
    let topicH2 = seoData.projectsHeader || i18n('developerH2');
    topicH2 = (
      <div {...bemClasses('rowTopic')}>
        <div {...bemClasses('text', 'h2')}><h2 children={topicH2}/></div>
      </div>
    );
    // const projects = get(this, 'props.projects.data');
    // const isLC = findIndex(projects, project => project.type === 'living_complex') > -1;
    let data = sortBy(childLandings.data, item => item.data.sort);
    let selectedTab = 0;
    let idx = 0;

    if (!data) return null;
    if (data && data.length === 1) {
      // if (!isLC) return null;

      return <Container body children={topicH2} />
    }
    //
    // If builder has only one region - show only one tab with name of this region
    if (data.length === 2) {
      data[0].data.name = data[1].data.name;
      data = [data[0]];
    }
    each(data, (land, key) => {
      if (params.url === land.url) selectedTab = idx;
      idx += 1;
      const name = land.data.name || i18n('developerLand');

      childTabs.push(
        <tab
          key={key}
          title={name}
          linkProps={{
            builder: linksDomik.sectionLanding,
            saveScrollState: true,
            builderProps: {
              ...land,
              query,
              name
            }
          }}
        />
      );
    });

    return (
      <Container body>
        {topicH2}
        <div {...bemClasses('tabs', 'main')}>
          <TabJSControl
            selectedTab={selectedTab}
            linkMode
          >
            {childTabs}
          </TabJSControl>
        </div>
        <div {...bemClasses('filters')}>
          <Dict
            url="location/living-complex/build-status-filter"
            injectPropName="listBoxItems"
          >
            <InputListBox
              dictValue="value"
              nullValueLabel={i18n('developerFilterAllProjects')}
              value={get(this, 'props.location.query.bildReadyStatus')}
              onChange={val =>
                this.updateState({ bildReadyStatus: { val } })
              }
              horizontal
              noError
            />
          </Dict>
        </div>
      </Container>
    );
  }

  handleCardUnhover = () => {
    this.showOnMap = null;
    if (this.hoverLayerRef) this.hoverLayerRef.setData(null);
  };

  renderProjects = (projects) => {
    if (!projects || !projects.data || !projects.data.length) return null;

    return (
      <>
        <Row>
          <Col {...bemClasses('col', 'projects')} allPr={0}>
            <div {...bemClasses('projects')}>
              <FavoriteWrapper
                project="domik"
                entity="location"
              >
                {({ data }) => map(projects.data, (item, key) => (
                  <TileCard
                    key={key}
                    object={item}
                    favData={data}
                  />
                ))}
              </FavoriteWrapper>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  renderWebsite(website, titleDeveloper) {
    if (!website) return null;

    return (
      <div {...bemClasses('links')}>
        <Icon {...bemClasses('icon')} type={iconTypes.planetThin} />
        <Link
          {...bemClasses('link')}
          href={website}
          title={this.i18n('developerLinkToSiteTitle')}
          dataProps={titleDeveloper ? { 'data-gtm-dev': titleDeveloper } : null}
          external
          blank
        >
          <span {...bemClasses('linkContent')}>
            <span {...bemClasses('text')} children={urlShortener(website)} />
          </span>
        </Link>
      </div>
    );
  }

  renderUrlForum(url, title) {
    if (!url) return null;

    return (
      <div {...bemClasses('links', 'forum')}>
        <Icon {...bemClasses('icon')} type={iconTypes.commentRound} />
        <Link
          {...bemClasses('link')}
          href={url}
          title={title}
          noRedirector
          external
        >
          <span {...bemClasses('linkContent')}>
            <span {...bemClasses('text')} children={title} />
          </span>
        </Link>
      </div>
    );
  }

  renderPhones =(phones, developer_id)=> {
    if (!phones || !phones.length || !developer_id) return null;

    return (
      <div {...bemClasses('links', 'phones')}>
        <Icon {...bemClasses('icon', 'phone')} type={iconTypes.phoneCalls} />
        {map(phones, (phone, key) => (
          <Fragment key={key}>
            <Counter
              action="phoneClick"
              entity={{developer_id}}
              mode="click"
              injectClickName="onClick"
            >
              <HideTelephoneSeo
                {...bemClasses('link', 'telSeo')}
                phone={phone}
                slicedNumber={6}
                btnLabel={'\u00a0xx xx'}
                classMods={{
                  telBild: true
                }}
              />
            </Counter>
            {phones.length !== key + 1 &&
              ', '
            }
          </Fragment>
        ))}
      </div>
    );
  }

  renderSocialsBlock(socials = {}, website, titleDeveloper, contact_email) {
    if (!socials && every(socials, it => !it) && !website && !contact_email) return null;

    const { i18n } = this;

    return (
      <Col {...bemClasses('col', 'socials')} allFlex allPr={0}>
        <div {...bemClasses('socials')}>
          {map(socials, (soc, key) => {
            if (soc && socialsIconConfig[key]) {
              if (key === 'viber') return <ViberPhone key={key} phone={socials.viber} />;
              if (key === 'telegram') return <TelegramPhone key={key} phone={socials.telegram} />;
              if (key !== 'viber' && key !== 'telegram') {
                return (
                  <Link
                    key={key}
                    {...bemClasses('link', ['social', socialsIconConfig[key]])}
                    href={soc}
                    external
                    blank
                  >
                    <span {...bemClasses('linkContent')}>
                      <Icon {...bemClasses('icon')} type={socialsIconConfig[key]} />
                    </span>
                  </Link>
                );
              }
            }

            return null;
          })}
          {website &&
            <Link
              {...bemClasses('link', 'website')}
              href={website}
              title={i18n('developerLinkToSiteTitle')}
              dataProps={titleDeveloper ? { 'data-gtm-dev': titleDeveloper } : null}
              external
              blank
            >
              <span {...bemClasses('linkContent')}>
                <Icon {...bemClasses('icon')} type={iconTypes.planetThinFill} />
                <span {...bemClasses('text')} children={urlShortener(website)} />
              </span>
            </Link>
          }
          {contact_email && this.renderButtonToAskQuestion()}
        </div>
      </Col>
    );
  }

  renderButtonToAskQuestion =()=> {
    const { i18n } = this;

    return (
      <Button
        {...bemClasses('btn', 'toAskQuestion')}
        onClick={this.scrollToAskQuestion}
        label={i18n('btnToAskQuestionText')}
        title={i18n('btnToAskQuestionText')}
        iconType={iconTypes.comment}
        contentLeft
      />
    );
  }

  renderDescription(textDescription) {
    const { i18n } = this;

    return (
      <div {...bemClasses('description')}>
        {textDescription &&
          <CollapseLines
            itemClassName={bemClasses('text', 'description').className}
            text={textDescription}
            moreText={i18n('moreDetails')}
            lessText={i18n('hide')}
            linesConfig={{
              desktop: 6,
              tablet: 6,
              phone: 3
            }}
          />
        }
      </div>
    );
  }

  renderAskDeveloperQuestion =(data)=> {
    if (!data.contact_email) return false;

    const url = get(this, 'props.params.url', '');
    const { i18n } = this;

    return (
      <AskQuestion
        {...bemClasses('blockAskQuestion')}
        ref={ref => this.askQuestionRef = ref}
        controller="support/ask-question/ask-developer-question"
        entityId={data.id}
        entity="ask_question"
        url={url}
        otherProps={{
          notificationMessageSuccess: i18n('askQuestionMessage'),
          inputPhoneProps: { noLabel: true, noElementBefore: true },
          additionalMain: false,
          headerTopic: true,
          headerTopicText: i18n('Задать вопрос застройщику'),
          firstSeller: data,
          hideTelephoneBtnIconType: iconTypes.phoneCalls,
          marker
        }}
      />
    );
  }

  scrollToAskQuestion =()=> {
    this.scrollToRef(this.askQuestionRef);
  }

  scrollToRef =(ref)=> {
    const isSensor = this.sensor;
    const heightHeader = toNumber(isSensor.getVariable('heightHeaderPx'));

    scrollToComponent(ref, { offset: -heightHeader, align: 'top', duration: 700, ease: 'linear' });
  }

  renderOfficeLocation =(userData)=> {
    const { i18n } = this;
    const address = get(userData, 'info.address');
    const tel = get(userData, 'phones[0]');

    return (
      <div {...bemClasses('blockMap')}>
        <Container body>
          <div {...bemClasses('rowTopic')}>
            <div {...bemClasses('text', 'h2')}><h2 children={i18n('mapTopic')} /></div>
          </div>
          <div {...bemClasses('content')}>
            {address &&
              <div {...bemClasses('address')}>
                <div {...bemClasses('text', 'label')} children={i18n('addressLabel')} />
                <div {...bemClasses('text', 'address')} children={address} />
              </div>
            }
            {tel &&
              <HideTelephoneSeo
                {...bemClasses('link', 'tel')}
                phone={tel}
                slicedNumber={false}
                btnBeforeText={<Icon {...bemClasses('icon', 'tel')} type={iconTypes.phoneCalls} />}
                btnLabel={i18n('call')}
                classMods={{
                  telBild: true
                }}
              />
            }
            {userData.contact_email && this.renderButtonToAskQuestion()}
          </div>
          {this.renderDeveloperMap(userData)}
          {this.renderAskDeveloperQuestion(userData)}
        </Container>
      </div>
    );
  }

  getCountLC(projects) {
    if (!projects) return null;
    const filteredLC = filter(projects, it => it.type === 'living_complex');

    return filteredLC.length;
  }

  handleScreenClick=()=> {
    this.setState({ isFullScreenMode: !(this.state.isFullScreenMode) });
  }

  renderDeveloperMap =(creator = {})=> {
    if (!creator.geo) return null;

    const { isFullScreenMode } = this.state;

    return (
      <div {...bemClasses('mapContainer')}>
        <Fullscreen
          enabled={isFullScreenMode}
          onChange={
            isFullScreen => this.setState({
              isFullScreenMode: isFullScreen
            })
          }
        >
          <Maps
            {...bemClasses('map')}
            noAutoGeolocate
            adaptiveScrollZoom={2000}
            maxZoom={17}
          >
            <BaseLayersUser key="bl" />
            {!isMobileSafari &&
              <FullscreenControl
                key="fs"
                isFullscreen={isFullScreenMode}
                onScreenIconClick={this.handleScreenClick}
                position="topleft"
              />
            }
            <InfoLayer
              key="gc"
              noAutoFit
              data={[creator.geo]}
              maxZoom={18}
              markerProps={{ icon: marker() }}
            />
            <InfoLayer
              fitMaxZoom={17}
              minZoom={19}
              key="il"
              data={[creator.geo]}
            />
          </Maps>
        </Fullscreen>
      </div>
    );
  };

  render() {
    const { i18n } = this;
    const {
      className, seoData, projects = {}, dev = {}, params: { landing, url }, location
    } = this.props;
    const { data = [] } = dev;
    const userData = data[0] || {};
    const {
      info, avatar, website, living_complex_counters = [], phones,
      rel_finished_cottage_towns, company_name, contact_email, id, url_forum
    } = userData;
    const { main_photo, work_start_date, about_us, clients_offer, sn, address } = info;
    const { id: avatarLogo } = avatar;
    const topic = seoData && seoData.header ? seoData.header : company_name;
    const seoLocation = get(location, 'pathname');
    const seoText = get(seoData, 'bottomText', null);
    const { isFullScreenMode, fullMapLegend } = this.state;
    const housesCounter = getHousesCounter.call(null, living_complex_counters);
    const minBuiltYear = housesCounter.ready_house_from_year ?
      i18n('developerYear', { placeholder: housesCounter.ready_house_from_year }) : '';
    const avatarDeveloper = { ...avatar, alt: topic, title: topic };
    const countLC = this.getCountLC(projects.data);
    let textDescription = about_us;
    if (clients_offer) textDescription = about_us ? about_us + '<br />' + clients_offer : clients_offer;

    return (
      <div {...bemClasses({ extra: className })}>
        <LazyHydrate ssrOnly>
          <OpenGraphImage imageId={avatarLogo} />
        </LazyHydrate>
        {this.needCount &&
          <Counter
            entity={{
              developer_id: userData.id
            }}
            mode="view"
            action="pageDeveloperView"
          />
        }
        <div {...bemClasses('imgMainContainer')}>
          <Image
            {...bemClasses('imgMain')}
            image={{
              id: main_photo,
              renderer: 'orig',
              alt: i18n('developerImgAlt', { placeholder: topic })
            }}
            fullScreenSwitch="none"
            imgOrigin
          />
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'ImageObject',
              name: topic ? i18n('developerImgAlt', { placeholder: topic }) : null,
              description: topic ? i18n('developerImgAlt', { placeholder: topic }) : null,
              contentUrl: main_photo ? absoluteUrl(`/images/thumb/full/${main_photo}`) : null
            }}
          />
        </div>
        <Container body>
          <Row {...bemClasses('row', 'main')} allColumn>
            {this.renderSocialsBlock(sn, website, topic, contact_email)}
            <Col allPr={0}>
              <Row {...bemClasses('row', 'bottom')}>
                <Col {...bemClasses('col', 'logo')} allAuto allPr={0}>
                  {avatar &&
                    <>
                      <Thumb
                        {...bemClasses('logo')}
                        image={avatarDeveloper}
                      />
                      <JsonLd
                        item={{
                          '@context': 'https://schema.org',
                          '@type': 'ImageObject',
                          name: get(avatarDeveloper, 'alt', null),
                          description: get(avatarDeveloper, 'title', null),
                          contentUrl: get(avatar, 'id') ? absoluteUrl(`/images/thumb/full/${avatar.id}`) : null
                        }}
                      />
                    </>
                  }
                </Col>
                <Col {...bemClasses('col', 'main')} allPr={0}>
                  <div {...bemClasses('title')}>
                    <div {...bemClasses('text')}><h1 children={topic} /></div>
                  </div>
                  {this.renderWebsite(website, topic)}
                  {this.renderPhones(phones, id)}
                  {this.renderUrlForum(url_forum, i18n('developerForum', { placeholder: company_name }))}
                  {this.renderDescription(textDescription)}
                </Col>
                <Col {...bemClasses('col', 'numeric')} allAuto allPr={0}>
                  {work_start_date &&
                    <div {...bemClasses('item', 'workStartDate')}>
                      <span
                        {...bemClasses('text', 'numeric')}
                        children={formatDate({ date: work_start_date, format: 'yyyy' })}
                      />
                      <span {...bemClasses('text')} children={i18n('developerFoundedYearText')} />
                    </div>
                  }
                  {+rel_finished_cottage_towns > 0 &&
                    <div {...bemClasses('item')}>
                      <span
                        {...bemClasses('text', 'numeric')}
                        children={beautifyNumber(+rel_finished_cottage_towns || 0)}
                      />
                      <span
                        {...bemClasses('text')}
                        children={`${numDescOnlyText(
                          +rel_finished_cottage_towns || 0,
                          i18n('developerHouseReadyCT'),
                          i18n('developerHouseReadyCTDeclination'),
                          i18n('developerHouseReadyCTMultiple')
                        )}`}
                      />
                    </div>
                  }
                  {!!countLC &&
                    <>
                      <div {...bemClasses('item')}>
                        <span
                          {...bemClasses('text', 'numeric')}
                          children={beautifyNumber(housesCounter.ready_house_number || 0)}
                        />
                        <span
                          {...bemClasses('text')}
                          children={`${numDescOnlyText(
                            housesCounter.ready_house_number || 0,
                            i18n('developerHouseReady'),
                            i18n('developerHouseReadyDeclination'),
                            i18n('developerHouseReadyMultiple')
                          )} ${i18n(
                            'developerInCount',
                            { placeholder: beautifyNumber(housesCounter.ready_house_in_lc_number || 0) }
                          )}${minBuiltYear}`}
                        />
                      </div>
                      <div {...bemClasses('item')}>
                        <span
                          {...bemClasses('text', 'numeric')}
                          children={beautifyNumber(housesCounter.in_progress_house_number || 0)}
                        />
                        <span
                          {...bemClasses('text')}
                          children={`${numDescOnlyText(
                            housesCounter.in_progress_house_number || 0,
                            i18n('developerHouseBuilt'),
                            i18n('developerHouseBuiltDeclination'),
                            i18n('developerHouseBuiltMultiple')
                          )} ${i18n(
                            'developerInCount',
                            { placeholder: beautifyNumber(housesCounter.in_progress_house_in_lc_number || 0) }
                          )}`}
                        />
                      </div>
                    </>
                  }
                </Col>
              </Row>
              {/*
              <Row {...bemClasses('block', 'descriptionDates')} mtColumn mpColumn>
                <Col allAuto allPr={0}>
                  <Row {...bemClasses('row', 'dates')} allAuto>
                    <Col {...bemClasses('col')} allPr={0}>
                      {work_start_date &&
                        <>
                          <div>
                            <span {...bemClasses('text', 'main')} children={formatDate({ date: work_start_date, format: 'yyyy' })} />
                          </div>
                          <div>
                            <span {...bemClasses('text')} children="Год основания" />
                          </div>
                        </>
                      }
                    </Col>
                    <Col {...bemClasses('col')} allPr={0}>
                      <div>
                        <span {...bemClasses('text', 'main')} children={beautifyNumber(housesCounter.ready_house_number || 0)} />
                      </div>
                      <div>
                        <span {...bemClasses('text')} children={`${numDescOnlyText(housesCounter.ready_house_number || 0, 'Готовый дом', 'Готовых дома', 'Готовых домов')} в\u00a0${beautifyNumber(housesCounter.ready_house_in_lc_number || 0)}\u00a0ЖК${minBuiltYear}`} />
                      </div>
                    </Col>
                    {rel_finished_cottage_towns > 0 &&
                      <Col {...bemClasses('col')} allPr={0}>
                        <div>
                          <span
                            {...bemClasses('text', 'main')}
                            children={beautifyNumber(rel_finished_cottage_towns || 0)}
                          />
                        </div>
                        <div>
                          <span
                            {...bemClasses('text')}
                            children={`${numDescOnlyText(+rel_finished_cottage_towns || 0, 'Готовый КП', 'Готовых КП', 'Готовых КП')}`}
                          />
                        </div>
                      </Col>
                    }
                    <Col {...bemClasses('col')} allPr={0}>
                      <div>
                        <span {...bemClasses('text', 'main')} children={beautifyNumber(housesCounter.in_progress_house_number || 0)} />
                      </div>
                      <div>
                        <span {...bemClasses('text')} children={`${numDescOnlyText(housesCounter.in_progress_house_number || 0, 'Дом строится', 'Дома строятся', 'Домов строятся')} в\u00a0${beautifyNumber(housesCounter.in_progress_house_in_lc_number || 0)}\u00a0ЖК`} />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              */}
            </Col>
          </Row>
        </Container>
        <LazyHydrate whenVisible>
          {contentBlock(blockConfig, 'userAdvert', this.props, { wrapper: BlockWrapper, withContainer: false, location: get(this, 'props.location') })}
        </LazyHydrate>
        <div {...bemClasses('block', 'projects')}>
          {this.renderNaviRegion()}
          <Container body>
            <DataProvider
              preloaded={projects}
              preloadedStatic
              renderer={this.renderProjects}
              reloadProvider={{ isFullScreenMode, fullMapLegend }}
            />
          </Container>
        </div>
        {this.renderOfficeLocation(userData)}
        <Container body>
          <LazyHydrate whenVisible>
            {contentBlock(blockConfig, 'bottom1', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blockConfig, 'bottom2', this.props, { wrapper: BlockWrapper, withContainer: false })}
          </LazyHydrate>
          <SeoText data={seoText} />
          <Breadcrumbs
            //TODO: Дима, почему-то нет хлебных крошех, а они не прилетели из лендитнгов
            data={landing.breadcrumbs}
            replace={{
              $developer: topic
            }}
          />
        </Container>
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'HomeAndConstructionBusiness',
            name: topic,
            url: absoluteUrl(url),
            description: textDescription,
            image: absoluteUrl(`/images/thumb/full/${main_photo}`),
            logo: absoluteUrl(`/images/thumb/full/${avatarLogo}`),
            sameAs: website,
            telephone: [phones],
            foundingDate: work_start_date,
            address: address || null,
            geo: get(userData, 'geo.coordinates') && get(userData, 'geo.type') === 'Point' ? {
              '@type': 'GeoCoordinates',
              latitude: userData.geo.coordinates[1],
              longitude: userData.geo.coordinates[0]
            } : null
          }}
        />
      </div>
    );
  }
}
